<h1 class="global-red" mat-dialog-title>
    You are not able to make edits to the Bank of America Background Check Form
</h1>

<mat-dialog-content>
    <p class="global-red">{{ thankYouMessage }}</p>
    <p>Your form is locked from editing and you can't make changes to the information already provided.</p>
    <p>Please click below to view your submitted applicant form.
    </p>

    <div class="centered">
        <button type="button" class="bofa--button secondary outlined" title="Download Applicant Form PDF"
            (click)="generatePDF()">Download Applicant Form PDF</button>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="is-taller">
        <div class="level">
            <div class="level-item">
                <button class="bofa--button secondary outlined" type="button" (click)="onNoClick()">Ok</button>
            </div>
        </div>
    </div>
</mat-dialog-actions>